import i18n from 'i18next';
import { toolsMcpEn } from '../i18n/tools-mcp-en';
import { toolsMcpEs } from '../i18n/tools-mcp-es';

const DICIONARIOS: Record<string, Record<string, string>> = { en: toolsMcpEn, es: toolsMcpEs };

/** Descrição de uma tool MCP no idioma ativo: pt devolve o texto do backend; en/es usam o dicionário, com a descrição original como reserva. */
export function descricaoDaTool(nome: string, descricaoPt: string): string {
  const idioma = (i18n.language ?? 'pt').slice(0, 2);
  return DICIONARIOS[idioma]?.[nome] ?? descricaoPt;
}
